import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles, Theme } from '@material-ui/core'
import {
    advancedFilterDefaultColor,
    listingDialogFilterContainerColor,
} from 'shared/common/productListingDialogColors'

export const useStyles = makeStyles((theme: Theme) => ({
    filterContainer: {
        display: 'flex',
        width: '9rem',
        paddingRight: '1rem',
        justifyContent: 'space-between',
    },
    header: {
        margin: 'unset',
        textAlign: 'left',
        width: '100%',
        height: pxToRem(47),
        color: theme.palette.common.white,
        fontSize: pxToRem(23),
        background: '#A78966',
    },
    headerText: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        textTransform: 'uppercase',
        paddingLeft: theme.spacing(3),
    },
    productHeader: {
        padding: theme.spacing(3),
        paddingBottom: theme.spacing(2),
    },
    actionButton: {
        display: 'inline-flex',
        borderRadius: 100,
        color: advancedFilterDefaultColor,
        padding: theme.spacing(0.75),
        margin: theme.spacing(0.75, 0),
        fontSize: pxToRem(14),
        fontWeight: 'normal',
        height: pxToRem(36),
        width: pxToRem(36),
        '&.MuiButton-root': {
            minWidth: 'unset',
        },
    },
    actionButtonFill: {
        color: theme.palette.common.white,
        background: '#A78966',
        '&:hover': {
            background: '#8F795F',
        },
    },
    iconIsActive: {
        backgroundColor: advancedFilterDefaultColor,
        color: listingDialogFilterContainerColor,
        borderRadius: '50%',
    },
}))
